import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	classificationFieldLabel: {
		id: 'issue-create-commons.data-classification-field.classification-field-label',
		defaultMessage: 'Classification level',
		description: 'This will be used as the field name for classification field',
	},

	projectDefaultClassificationOption: {
		id: 'issue-create-commons.data-classification-field.project-default-classification-option',
		defaultMessage: 'Project default',
		description: 'This is the project default option',
	},

	noClassificationOption: {
		id: 'issue-create-commons.data-classification-field.no-classification-option',
		defaultMessage: 'Project default - No classification',
		description: 'This is no classification option',
	},
});
